import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { AccessGroupSelector } from "../../../components/AccessGroupSelector/AccessGroupSelector";
import Form from "../../../components/Form/Form";
import FormTitle from "../../../components/FormTitle/FormTitle";
import Input from "../../../components/Input/Input";
import "./FormAccessRoutes.css";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { LuRoute } from "react-icons/lu";
import AccessRouteService from "../../../services/AccessRoutesService";
import { TagSelectorBox } from "../../../components/TagSelectorBox/TagSelectorBox";

function mapSelectedGroup(group) {
   const groupId = group.originalId ?? group.id;
   return {
      ...group,
      id: `${groupId}`,
      originalId: groupId,
      value: `${groupId}`,
      label: group.name ?? group.label,
   };
}

export function FormAccessRoutes(props) {
   const [name, setName] = useState(props.accessRoute?.name);
   const [enabled, setEnabled] = useState(props.accessRoute?.enabled ?? false);
   const [groupsSelected, setGroupsSelected] = useState(
      (props.accessRoute?.groups ?? []).map(mapSelectedGroup)
   );
   const [tags, setTags] = useState([]);

   useEffect(() => {
      setName(props.accessRoute?.name);
      setEnabled(props.accessRoute?.enabled);
      setTags(props.accessRoute?.tags?.map(tag => tag.tagId));
      setGroupsSelected((props.accessRoute?.groups ?? []).map(mapSelectedGroup));
   }, [props.accessRoute]);

   const navigate = useNavigate();

   const buildPayload = () => {
      let payload = {
         name,
         enabled,
         groups: groupsSelected?.map(groupSelected => groupSelected.originalId ?? groupSelected.id) || [],
         tags,
         uuid: uuidv4(),
      };
      return payload;
   };

   async function handleSubmit(event) {
      event.preventDefault();
      if (props.type === "edicao") {
         handleEdit(event);
         return;
      }
      const payload = buildPayload();
      const response = await AccessRouteService.createAccessRoute(payload);
      if (response.data.id) navigate("../consulta-access-routes", {
         state: { refresh: true }
      });
   }

   async function handleEdit(event) {
      event.preventDefault();
      const payload = buildPayload();
      const response = await AccessRouteService.updateAccessRoute(
         props.accessRoute.id,
         payload
      );
      if (response.data.id) navigate("../consulta-access-routes");
   }

   async function handleDelete() {
      if (!props.accessRoute) return;
      await AccessRouteService.deleteAccessRoute(props.accessRoute.id);
      navigate("../consulta-access-routes", {
         state: { deletedId: props.accessRoute.id },
      });
   }

   const handleClickEditButton = () => {
      if (!props.accessRoute) return;
      navigate(`/access-routes/${props.accessRoute.uuid}`, { state: props.accessRoute });
   };

   return (
      <>
         {!props.isTemp && (
            <FormTitle
               type={props.type}
               icon={<LuRoute size={20} />}
               tituloConsulta={props.accessRoute?.name || null}
               tituloCadastro="Cadastro de Rota de Acesso"
               backRoute={"/consulta-access-routes"}
            />
         )}
         <Form
            handleSubmit={handleSubmit}
            type={props.type}
            handleClickEdit={handleClickEditButton}
            handleDelete={handleDelete}
            navigateCancelUrl="../consulta-access-routes"
            deleteButNotSynqed={props.accessRoute?.deletedAt ? true : false}
         >
            <div className="w-full grid grid-cols-1 gap-6">
               <div className="form-cond-container" style={{ width: '100%' }}>
                  <Input
                     name="name"
                     id="name"
                     labelText="Nome *"
                     value={name}
                     onChange={({ target }) => { setName(target.value); }}
                     disabled={props.type === "consulta"}
                     required={true}
                     tooltipText="Nome da rota de acesso"
                     tooltipVisible={true}
                  />
               </div>
               {props.type !== "consulta" && (
                  <TagSelectorBox
                     action={props.type}
                     tags={tags}
                     customFilter={(tag) => tag.licensePerson === true}
                     type={'PERSON'}
                     onTagsChange={tags => setTags(tags)}
                  />
               )}
               <div className='flex flex-col items-start gap-3.5 my-2'>
                  <ToggleButton
                     style={{ width: 'fit-content' }}
                     label={`Habilitado`}
                     onChange={(e) => setEnabled(e.target.checked)}
                     disabled={props.type === "consulta"}
                     selected={enabled}
                  />
               </div>
               {props.type !== "consulta" && (
                  <AccessGroupSelector
                     groups={groupsSelected}
                     onChange={selectedGroups => setGroupsSelected(selectedGroups.map(mapSelectedGroup))}
                     disabled={props.type === "consulta"}
                  />
               )}
            </div>
         </Form>
      </>
   );
}
